import React, { useState, useEffect } from 'react';
import { myAxios } from '../../services/Helper';

const PaymentTest = () => {
    const [loading, setLoading] = useState(false);
    const [testResult, setTestResult] = useState(null);
    const [orderResult, setOrderResult] = useState(null);
    
    useEffect(() => {
        const loadRazorpayScript = () => {
            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = 'https://checkout.razorpay.com/v1/checkout.js';
                script.onload = () => {
                    resolve(true);
                };
                script.onerror = () => {
                    resolve(false);
                };
                document.body.appendChild(script);
            });
        };

        loadRazorpayScript();
    }, []);
    
    const testConnection = async () => {
        setLoading(true);
        try {
            const response = await myAxios.post('/api/payment/test-connection');
            setTestResult(response.data);
        } catch (error) {
            console.error('Test connection error:', error);
            setTestResult({ error: error.message });
        } finally {
            setLoading(false);
        }
    };
    
    const testOrder = async () => {
        setLoading(true);
        try {
            const response = await myAxios.post('/api/payment/test-order');
            
            // Try to parse the response
            let orderData;
            if (typeof response.data === 'string') {
                try {
                    orderData = JSON.parse(response.data);
                } catch (parseError) {
                    orderData = { parseError: parseError.message, rawData: response.data };
                }
            } else {
                orderData = response.data;
            }
            
            setOrderResult(orderData);
            
            // Open Razorpay checkout for testing
            if (orderData && orderData.id) {
                openRazorpayCheckout(orderData.id);
            }
        } catch (error) {
            console.error('Test order error:', error);
            setOrderResult({ error: error.message });
        } finally {
            setLoading(false);
        }
    };
    
    const openRazorpayCheckout = (orderId) => {
        try {
            const options = {
                key: "rzp_test_3zJGtRaGdc9DPM",
                amount: 100, // 1 rupee in paise
                currency: "INR",
                name: "Waghchaure Lawns",
                description: "Test Payment",
                image: "https://shubhamjadhav.in/images/lockedme.jpg",
                order_id: orderId,
                handler: function (response) {
                    alert('Payment successful! \n\nPayment ID: ' + response.razorpay_payment_id + 
                          '\nOrder ID: ' + response.razorpay_order_id + 
                          '\nSignature: ' + response.razorpay_signature);
                },
                prefill: {
                    name: "Test User",
                    email: "test@example.com",
                    contact: "9999999999"
                },
                theme: {
                    color: "#3399cc"
                }
            };
            
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error('Error opening Razorpay:', error);
            alert('Could not open payment page: ' + error.message);
        }
    };
    
    return (
        <div className="container mt-5">
            <h2>Razorpay Integration Test</h2>
            
            <div className="card mb-4">
                <div className="card-body">
                    <h5 className="card-title">Test Razorpay Connection</h5>
                    <button 
                        className="btn btn-primary"
                        onClick={testConnection}
                        disabled={loading}
                    >
                        {loading ? 'Testing...' : 'Test Connection'}
                    </button>
                    
                    {testResult && (
                        <div className="mt-3">
                            <h6>Test Results:</h6>
                            <pre className="bg-light p-3 rounded">
                                {JSON.stringify(testResult, null, 2)}
                            </pre>
                        </div>
                    )}
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Test Order Creation</h5>
                    <button 
                        className="btn btn-success"
                        onClick={testOrder}
                        disabled={loading}
                    >
                        {loading ? 'Creating...' : 'Create Test Order'}
                    </button>
                    
                    {orderResult && (
                        <div className="mt-3">
                            <h6>Order Results:</h6>
                            <pre className="bg-light p-3 rounded">
                                {JSON.stringify(orderResult, null, 2)}
                            </pre>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentTest; 